// QuickTestSync.jsx - Bottone Test Minimalista
// Copia questo file in src/components/Admin/

import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

const QuickTestSync = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleTest = async () => {
    setLoading(true);
    setResult(null);
    
    try {
      const functions = getFunctions();
      const sync = httpsCallable(functions, 'manualRapportiniSync');
      
      // Data di ieri
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const date = yesterday.toISOString().split('T')[0];
      
      console.log(`🔄 Test sincronizzazione ${date}...`);
      
      const response = await sync({ date });
      
      console.log('✅ Risultato:', response.data);
      setResult(response.data);
      
      alert(`✅ Sincronizzazione completata!\n\nRapportini aggiornati: ${response.data.stats.rapportiniUpdated}\nPersone aggiornate: ${response.data.stats.personeUpdated}`);
      
    } catch (error) {
      console.error('❌ Errore:', error);
      alert(`❌ Errore: ${error.message}`);
      setResult({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', background: '#f0f0f0', borderRadius: '8px', marginBottom: '20px' }}>
      <h3 style={{ margin: '0 0 15px 0' }}>🧪 Test Sincronizzazione Rapportini</h3>
      
      <button 
        onClick={handleTest}
        disabled={loading}
        style={{
          padding: '12px 24px',
          background: loading ? '#95a5a6' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          fontSize: '16px',
          fontWeight: 'bold',
          cursor: loading ? 'not-allowed' : 'pointer',
          transition: 'all 0.3s'
        }}
      >
        {loading ? '⏳ Test in corso...' : '🔄 Test Sync Ieri'}
      </button>
      
      {result && (
        <div style={{ 
          marginTop: '15px', 
          padding: '15px', 
          background: result.error ? '#fee' : '#efe',
          borderRadius: '6px',
          fontSize: '14px'
        }}>
          {result.error ? (
            <div>❌ <strong>Errore:</strong> {result.error}</div>
          ) : (
            <div>
              ✅ <strong>Completato!</strong><br />
              Rapportini aggiornati: {result.stats.rapportiniUpdated}<br />
              Persone aggiornate: {result.stats.personeUpdated}
            </div>
          )}
        </div>
      )}
      
      <p style={{ marginTop: '15px', fontSize: '12px', color: '#666' }}>
        💡 Questo bottone sincronizza i rapportini di ieri con le ore in workHours.<br />
        Per vedere i log completi, apri la Console (F12).
      </p>
    </div>
  );
};

export default QuickTestSync;